import { App, createApp, ref } from "vue";
/* eslint-disable @typescript-eslint/naming-convention */
import NotificationPopupsList from "./notification-popups-list.vue";
import NotificationPopupProps from "./notification-popup-props";

const notificationsPopupsRootId = "notification-popups-root";

let listComponent: App<Element> = null;
const notificationDataStorage = ref<NotificationPopupProps[]>([]);

const initNotificationPopupsList = () => {
    let root = document.getElementById(notificationsPopupsRootId);

    if (root) return;

    root = document.createElement("div");
    root.id = notificationsPopupsRootId;
    document.body.appendChild(root);

    listComponent = createApp(NotificationPopupsList, {
        notifications: notificationDataStorage.value,
        onDestroyPopup: (notificationId: number) => {
            notificationDataStorage.value.splice(
                notificationDataStorage.value.findIndex((notification) => notification.id == notificationId),
                1
            );

            if (!notificationDataStorage.value.length) {
                listComponent.unmount();
                listComponent = null;
                root.remove();
            }
        },
    });

    listComponent.mount(root);
};

export function useNotificationPopup(data: NotificationPopupProps) {
    notificationDataStorage.value.push(data);

    if (!listComponent) {
        initNotificationPopupsList();
    }
}
